import React, { FunctionComponent, useState } from 'react';
import Icon from "../../../../../components/Icon";
import { isThread } from "../../../../../types";
import { Slider } from "../../../../../components";
import { usePolyglot } from "../../../../../context/Polyglot";
import {
    selectCanAdminAllPublicGroups,
    selectCurrentUserId,
} from "../../../../../redux/slices";
import { useTypedSelector } from "../../../../../redux/hooks";
import styles from '../styles.module.scss';
import { StyledButton } from "../../../../../components/StyledComponents";
import { ChatSettingsSidebarMenus } from "../../index";
import { useConversationContext } from '../../../../../context/ChatContext/contextConvo';
import { nebulaChatApi } from '../../../../../redux/services/nebulaChat';

interface Props {
    setSideBarTab: (val: ChatSettingsSidebarMenus) => void;
}

const ChatSettingsMenuOptions: FunctionComponent<Props> = ({ setSideBarTab }) => {
    const { conversation, updateMember } = useConversationContext();
    const { t } = usePolyglot();

    const canAdminPublicGroups = useTypedSelector(selectCanAdminAllPublicGroups);
    const userUuid = useTypedSelector(selectCurrentUserId);

    const [leaveGroupWarning, setLeaveGroupWarning] = useState<boolean>(false);

    const [channelAction] = nebulaChatApi.endpoints.channelActionN.useMutation()

    return (
        <div className={styles.menu_actions}>
            {conversation.type === 'channel' && (canAdminPublicGroups || conversation.created_by === userUuid) ? (
                <StyledButton
                    buttonStyle='text'
                    onClick={() => setSideBarTab('addMembers')}
                >
                    <Icon name='addContact' ariaHidden />
                    <p>{t("actions.add_user", 2)}</p>
                </StyledButton>
            ) : null}
            <StyledButton
                onClick={() => updateMember({ is_favourite: !conversation.is_favourite })}
                buttonStyle='text'
            >
                <Icon name='pin' ariaHidden />
                <p>{t(`actions.${conversation.is_favourite ? 'unpin' : 'pin'}_${isThread(conversation) ? 'thread' : 'chat'}`)}</p>
                <Slider
                    name={t("phrases.chat_pinned")}
                    checked={conversation.is_favourite}
                    readOnly
                    tabIndex={-1}
                />
            </StyledButton>
            {!isThread(conversation) ? (
                <StyledButton
                    onClick={() => updateMember({ is_muted: !conversation.is_muted })}
                    buttonStyle='text'
                >
                    <Icon name='muteUnfilled' ariaHidden />
                    <p>{t("actions.mute_chat")}</p>
                    <Slider
                        name={t("phrases.presence_do_not_disturb")}
                        checked={conversation.is_muted}
                        readOnly
                        tabIndex={-1}
                    />
                </StyledButton>
            ) : null}
            {conversation.type === 'channel' ? (
                <div className={styles.danger_select}>
                    <StyledButton
                        buttonStyle='text'
                        context='danger'
                        onClick={() => setLeaveGroupWarning(true)}
                        disabled={leaveGroupWarning}
                    >
                        <Icon name='logout' ariaHidden />
                        <p>
                            {leaveGroupWarning ?
                                t("phrases.are_you_sure")
                                : t("actions.leave_group")
                            }
                        </p>
                    </StyledButton>
                    {leaveGroupWarning ? (<>
                        <StyledButton
                            buttonStyle='tertiary'
                            context='danger'
                            onClick={() => {
                                channelAction({
                                    channel_uuid: conversation.uuid,
                                    action: 'leave'
                                })
                            }}
                        >
                            <p>{t("actions.confirm")}</p>
                        </StyledButton>
                        <StyledButton
                            buttonStyle='tertiary'
                            onClick={() => setLeaveGroupWarning(false)}
                        >
                            <p>{t("actions.cancel")}</p>
                        </StyledButton>
                    </>) : null}
                </div>
            ) : null
            }
        </div >
    );
};

export default ChatSettingsMenuOptions;
